import { EventSource } from '@/types/events';

export const EVENT_SOURCES: { value: EventSource; label: string }[] = [
  { value: 'admin_console', label: 'Admin Console' },
  { value: 'api', label: 'API' },
  { value: 'hosted_page', label: 'Hosted Page' },
  { value: 'portal', label: 'Portal' },
  { value: 'scheduled_job', label: 'Scheduled Job' },
  { value: 'system', label: 'System' },
  { value: 'js_api', label: 'JS API' },
  { value: 'bulk_operation', label: 'Bulk Operation' },
  { value: 'external_service', label: 'External Service' },
  { value: 'none', label: 'None' },
];

export function formatSource(source: string): string {
  const found = EVENT_SOURCES.find((s) => s.value === source);
  return found?.label ?? source;
}
